module.exports = __webpack_public_path__ + "img/logo.d48e5403.png";